import React, { useState } from 'react';
import { StyledIcon } from './style';
import { Share } from '../../../../assets/images/index';
import TooltipBasic from '../../core/Tooltip/TooltipBasic';
import { TooltipCustom } from '../../core/Tooltip';

const CopiedUrl = ({ textUrl }) => {
  const [tooltipActive, setTooltipActive] = useState(false);
  const [tooltipMessage, setTooltipMessage] = useState('');

  const hideTooltip = () => {
    setTimeout(() => {
      setTooltipActive(false);
    }, 4000);
  };

  const copyToClipboard = text => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      return Promise.resolve(); // Simula éxito
    } catch (err) {
      return Promise.reject(err);
    } finally {
      document.body.removeChild(textArea);
    }
  };

  const handleIconClick = () => {
    copyToClipboard(textUrl)
      .then(() => {
        setTooltipActive(true);
        setTooltipMessage('Url copiada');
      })
      .catch(() => {
        setTooltipActive(true);
        setTooltipMessage('No se ha podido copiar la Url');
      })
      .finally(hideTooltip);
  };

  return (
    <div>
      {textUrl && (
        <TooltipCustom active={tooltipActive}>
          <StyledIcon
            onClick={handleIconClick}
            svg={Share}
            aria-label="Compartir url"
            size="m"
            profilee="button"
            hover
          />
          <TooltipBasic>
            <p>{tooltipMessage}</p>
          </TooltipBasic>
        </TooltipCustom>
      )}
    </div>
  );
};

export default CopiedUrl;
